import React from 'react';
import LocationTemplate from './LocationTemplate';

const OakCityPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Oak City"
      stateName="North Carolina"
      countyName="Martin"
      zipCodes={["27857"]}
      latitude={35.9618}
      longitude={-77.3014}
      population={317}
      historicalFact="Named after the abundant oak trees in the area when founded."
      nearbyTowns={[
        "Hamilton, NC",
        "Robersonville, NC",
        "Scotland Neck, NC",
        "Hobgood, NC",
        "Williamston, NC",
        "Windsor, NC",
        "Plymouth, NC",
        "Hassell, NC"
      ]}
    />
  );
};

export default OakCityPage;